<template>
    <div>
        <button id="chat" type="button" class="z-20 right-4 bottom-4 fixed inline-flex items-center p-3 border border-black rounded-full shadow-sm text-white bg-racing-stars-yellow hover:bg-racing-stars-yellow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
            <ChatIcon class="h-6 w-6 text-gray-800" aria-hidden="true" />
        </button>
    </div>
</template>
<script>
import { ref } from 'vue'
import { ChatIcon } from '@heroicons/vue/outline'

export default {
    components: {
        ChatIcon,
    }
}

</script>
